// extracted by css-extract-rspack-plugin
export default {"MonitorPageWrapper":"bFXTa","MonitorPageContent":"FSQI9"};